<template>
  <div>
    <div v-if="listLoadding == false">
      <Row :gutter="20" style="margin-top: 10px;">
        <i-col  v-for="item in poolDatas" :md="24" :lg="8" style="margin-bottom: 20px;">
          <Card shadow>
            <chart-pie style="height: 300px;" :value="item.datas" :text="item.name"></chart-pie>
          </Card>
        </i-col>
<!--        <i-col :md="24" :lg="8" style="margin-bottom: 20px;">-->
<!--          <Card shadow>-->
<!--            <chart-pie style="height: 300px;" :value="poolDatas[1]" text="用户访问来源"></chart-pie>-->
<!--          </Card>-->
<!--        </i-col>-->
      </Row>
    </div>
  </div>
</template>

<script>
import { ChartPie, ChartBar } from '_c/charts'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
export default {
  name: 'home',
  components: {
    ChartPie
  },
  data () {
    return {
      listLoadding: true,
      poolDatas: []
    }
  },
  methods: {
    loadLastData () {
      this.listLoadding = true
      store.dispatch('SimFlowPoolRecordServ_GetLastData', {
        params: null,
        urlparams: null
      }).then(() => {
        let datas = store.getters.get_SimFlowPoolRecord_GetLastDataResult
        console.log(datas)
        datas.forEach(item => {
          let name = null
          if (item.prdCode == '51314001146') {
            name = '4G流量池.'
          } else if (item.prdCode == '51314034579') {
            name = '离网停机组100M流量池'
          } else if (item.prdCode == '51314001222') {
            name = '2019年3G流量池-重点重点'
          } else if (item.prdCode == '51314001211') {
            name = '2020年3G流量池'
          } else if (item.prdCode == '51314001246') {
            name = '100M小流量池'
          }
          let pd = { name: name, datas: [] }
          pd.datas.push({ name: '已用流量', value: item.usedFlow })
          pd.datas.push({ name: '剩余流量', value: item.restFlow })
          this.poolDatas.push(pd)
        })
        console.log(this.poolDatas)
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    loadData () {
      this.listLoadding = true
      let queryParams = []
      let startDatetime = new Date().Format('yyyy-MM-dd 00:00:00')
      let endDatetime = new Date().Format('yyyy-MM-dd 23:59:59')
      queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
      store.dispatch('SimFlowPoolRecordServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams
        }
      }).then(() => {
        let datas = store.getters.get_SimFlowPoolRecord_GetPageResult
        console.log(datas)
        datas.content.forEach(item => {
          let name = null
          if (item.prdCode == '51314001146') {
            name = '4G流量池.'
          } else if (item.prdCode == '51314034579') {
            name = '离网停机组100M流量池'
          } else if (item.prdCode == '51314001222') {
            name = '2019年3G流量池-重点重点'
          } else if (item.prdCode == '51314001211') {
            name = '2020年3G流量池'
          } else if (item.prdCode == '51314001246') {
            name = '100M小流量池'
          }
          let pd = { name: name, datas: [] }
          pd.datas.push({ name: '已用流量', value: item.usedFlow })
          pd.datas.push({ name: '剩余流量', value: item.restFlow })
          this.poolDatas.push(pd)
        })
        console.log(this.poolDatas)
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      console.log('loadLastData')
      this.loadLastData()
    })
  }
}
</script>

<style lang="less">
.count-style{
  font-size: 50px;
}
</style>
